<template>
  <div class="mt-2">
    <v-layout>
      <v-flex>
        <v-btn flat @click="cancelProduct">
          <em class="fas fa-chevron-left mr-1" />
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <h3 class="headline mt-3">{{ $t('Add new product') }}</h3>

    <div class="form-control mt-3" :class="{ 'has-error': errors.has('categoryInput') }">
      <label for="categoryInput" class="caption">{{ $t('Category') }} *</label>
      <select-category
        v-model="category"
        v-validate="'required'"
        :pageid="pageid"
        data-vv-name="categoryInput"
        data-vv-as="Category"
        :selected="currentCategory"
        @onChangeCategory="onChangeCategory"
      ></select-category>
      <span v-show="errors.has('categoryInput')" class="text-error">
        {{ errors.first('categoryInput') }}
      </span>
    </div>
    <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
      <upload-multiple-file
        v-model="productImages"
        :max="10"
        data-vv-name="uploadMultipleFile"
        data-vv-as="Preview Image"
      ></upload-multiple-file>

      <span v-show="errors.has('uploadMultipleFile')" class="text-error">
        {{ errors.first('uploadMultipleFile') }}
      </span>
    </div>
    <v-layout v-if="selectedBot.theme == 'runkan'" row wrap>
      <v-flex xs6 class="pr-2">
        <div>ภาพพื้นหลังผลวิ่ง</div>
        <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
          <uploadfile
            v-model="product.photohash"
            :max="10"
            data-vv-name="อัพโหลดผลวิ่ง"
            data-vv-as="อัพโหลดผลวิ่ง"
          ></uploadfile>

          <span v-show="errors.has('uploadMultipleFile')" class="text-error">
            {{ errors.first('uploadMultipleFile') }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6>
        <div>ภาพพื้นหลัง E-Certificate</div>
        <div class="pb-3 form-control" :class="{ 'has-error': errors.has('uploadMultipleFile') }">
          <uploadfile
            v-model="product.source"
            :max="10"
            data-vv-name="อัพโหลดผลวิ่ง"
            data-vv-as="อัพโหลดผลวิ่ง"
          ></uploadfile>

          <span v-show="errors.has('uploadMultipleFile')" class="text-error">
            {{ errors.first('uploadMultipleFile') }}
          </span>
        </div></v-flex
      >
    </v-layout>

    <div class="form-control" :class="{ 'has-error': errors.has('nameInput') }">
      <label class="caption" for="nameInput">{{ $t('Product Name') }} *</label>
      <input
        id="nameInput"
        ref="name"
        v-model="product.name"
        v-validate="'required'"
        type="text"
        class="form-control"
        name="nameInput"
        :data-vv-as="$t('Product Name')"
        aria-describedby="name"
        :placeholder="$t('Product Name')"
        @blur="$set(product, 'name', noSpaceAndSpecial($event))"
      />
      <span v-show="errors.has('nameInput')" class="text-error">
        {{ errors.first('nameInput') }}
      </span>
    </div>

    <template v-if="selectedBot.pageid != '114660513608160'">
      <div class="form-control" :class="{ 'has-error': errors.has('codeInput') }">
        <label v-if="selectedBot.theme == 'runkan'" class="caption" for="codeInput">{{
          $t('ชื่อย่อโครงการ')
        }}</label>
        <label v-else class="caption" for="codeInput">{{ $t('SKU') }}</label>
        <input
          id="codeInput"
          v-model="product.code"
          type="text"
          class="form-control"
          name="codeInput"
          :data-vv-as="$t('SKU')"
          aria-describedby="SKU"
          :placeholder="$t('SKU')"
        />
        <span v-show="errors.has('codeInput')" class="text-error">
          {{ errors.first('codeInput') }}
        </span>
      </div>
    </template>

    <div class="form-control" :class="{ 'has-error': errors.has('priceInput') }">
      <label class="caption" for="priceInput">{{ $t('Price') }} *</label>
      <div class="form-inline">
        <div
          style="
            padding: 6px 12px;
            border-radius: 50%;
            display: inline-block;
            background: #eee;
            margin-right: 5px;
          "
        >
          {{ currencySign }}
        </div>
        <input
          id="priceInput"
          ref="price"
          v-model="product.price"
          v-validate="'required|decimal|min_value:0'"
          type="text"
          class="form-control"
          name="priceInput"
          :data-vv-as="$t('Price')"
          aria-describedby="price"
          :placeholder="$t('Price')"
          style="max-width: 150px; display: inline"
          @blur="$set(product, 'price', decimalOnly($event))"
        />
        &nbsp;
        <span v-show="errors.has('priceInput')" class="text-error">
          {{ errors.first('priceInput') }}
        </span>
      </div>
    </div>

    <div class="form-control" :class="{ 'has-error': errors.has('discountPriceInput') }">
      <label class="caption" for="dicountPriceInput">{{ $t('Sale price') }} *</label>
      <div class="form-inline">
        <div
          style="
            padding: 6px 12px;
            border-radius: 50%;
            display: inline-block;
            background: #eee;
            margin-right: 5px;
          "
        >
          {{ currencySign }}
        </div>
        <input
          id="discountPriceInput"
          v-model="product.discountprice"
          v-validate="'required|decimal|min_value:0|isLessThanOrEqual:price'"
          type="text"
          class="form-control"
          name="discountPriceInput"
          :data-vv-as="$t('Sale price')"
          aria-describedby="Sale Price"
          :placeholder="$t('Sale price')"
          style="max-width: 150px; display: inline"
          @blur="$set(product, 'discountprice', decimalOnly($event))"
        />
        <div
          v-if="
            product.discountprice &&
            parseFloat(product.discountprice) > 0 &&
            parseFloat(product.price) > parseFloat(product.discountprice)
          "
          class="text-xs-center"
          style="padding: 5px 10px; background: red; color: white; display: inline-block"
        >
          {{ (((product.price - product.discountprice) / product.price) * 100) | numberFormat }}%
        </div>
        <div
          v-else
          class="text-xs-center"
          style="padding: 5px 10px; background: #eee; color: white; display: inline-block"
        >
          0%
        </div>
        <div>
          <span v-show="errors.has('discountPriceInput')" class="text-error">
            {{ errors.first('discountPriceInput') }}
          </span>
        </div>
      </div>
    </div>

    <div
      v-if="selectedBot.theme == 'foodguru'"
      class="form-group form-control"
      :class="{ 'has-error': errors.has('productType') }"
    >
      <div style="margin-top: 20px">
        <label class="caption">{{ $t('Product Type') }} *</label>
      </div>
      <v-radio-group
        id="productType"
        v-model="product.producttype"
        v-validate="'required'"
        name="productType"
        :error="error"
        :data-vv-as="$t('Product Type')"
        :error-messages="errors.first('productType')"
        row
      >
        <v-radio label="ของสด" :value="'ของสด'" color="primary"></v-radio>
        <v-radio label="ของแห้ง" :value="'ของแห้ง'" color="primary"></v-radio>
      </v-radio-group>
    </div>

    <template v-if="selectedBot.pageid != '114660513608160'">
      <div
        style="margin-top: 20px"
        class="form-control"
        :class="{ 'has-error': errors.has('productWeightInput') }"
      >
        <label class="caption" for="productWeightInput"
          >{{ $t('Product Weight') }} ({{ $t('gram') }})</label
        >
        <div>
          <input
            id="productWeightInput"
            ref="productWeight"
            v-model="product.weight"
            v-validate="'decimal:2|min_value:0'"
            type="text"
            class="form-control"
            name="productWeightInput"
            :data-vv-as="$t('Product Weight')"
            aria-describedby="productWeight"
            :placeholder="$t('Product Weight')"
          />
          <span v-show="errors.has('productWeightInput')" class="text-error">
            {{ errors.first('productWeightInput') }}
          </span>
        </div>
      </div>
    </template>

    <div class="row">
      <div class="col s12"></div>

      <div class="col s12 px-0">
        <div
          class="form-group form-control"
          :class="{ 'has-error': errors.has('descriptionInput') }"
        >
          <div>
            <label for="descriptionInput" class="caption">{{ $t('Product detail') }} *</label>
          </div>
          <template
            v-if="$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)"
          >
            <VueEditor
              v-model="product.description"
              v-validate="'required'"
              name="descriptionInput"
              :data-vv-as="$t('Product detail')"
              :placeholder="$t('Product detail')"
              :editor-toolbar="customToolbar"
            />
          </template>
          <template v-else>
            <textarea
              id="descriptionInput"
              v-model="product.description"
              v-validate="'required'"
              type="text"
              class="form-control"
              name="descriptionInput"
              style="resize: vertical; min-height: 90px; width: 100%"
              :data-vv-as="$t('Product detail')"
              aria-describedby="description"
              :placeholder="$t('Product detail')"
              row="3"
            />
          </template>
          <span v-show="errors.has('descriptionInput')" class="text-error">
            {{ errors.first('descriptionInput') }}
          </span>
        </div>

        <template v-if="productstock">
          <ScgdisProductStock
            v-if="selectedBot.theme == 'scgdistribution'"
            v-model="productstock"
            :category="productstockcategories"
            :product="product"
            @close="close()"
            @updateCategory="updateCategory"
            @deleteStock="deleteStock"
          ></ScgdisProductStock>
          <product-stock
            v-else
            v-model="productstock"
            :category="productstockcategories"
            :product="product"
            @close="close()"
            @updateCategory="updateCategory"
            @deleteStock="deleteStock"
          ></product-stock>
        </template>
        <template
          v-if="selectedBot.pageid != '114660513608160' && !['runkan'].includes(selectedBot.theme)"
        >
          <template v-if="$store.getters.getPackage == 'premium'">
            <h3 class="headline">{{ $t('Wholesale') }}</h3>
            <product-bundle
              v-model="productbundle"
              :price="product.price ? parseFloat(product.price) : 0"
              @deleteBundle="deleteBundle"
            ></product-bundle>
          </template>
        </template>

        <template v-if="['runkan'].includes(selectedBot.theme)">
          <runkan-datetime v-model="runkandate" :type="'add'"></runkan-datetime>
        </template>

        <template v-if="$store.state.specialpage.includes(selectedBot.pageid)">
          <div class="hr" style="margin-top: 35px"></div>

          <template v-if="$store.getters.getPackage == 'premium'">
            <div class="text-xs-center" style="margin-top: -15px">
              <a
                class="btn-advanced"
                href="javascript:void(0);"
                @click="showAdvanced = !showAdvanced"
              >
                {{ $t('Advanced') }}
                <i
                  class="fa"
                  :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
                />
              </a>
            </div>

            <template v-if="showAdvanced">
              <div
                class="row form-control"
                :class="{ 'has-error': errorTag.length > 0 }"
                style="margin-top: 15px"
              >
                <div class="col s12">
                  <label class="caption" for="keywordInput">{{ $t('Keywords') }}</label>
                  <tags
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="(newTags) => (tags = newTags)"
                    @before-adding-tag="checkTag"
                  ></tags>
                  <span v-if="errorTag.length > 0" class="text-error">
                    <template v-if="errorTag.includes('duplicate')">
                      {{ $t('Duplicate Choice') }}
                    </template>
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col s12 m6">
                  <div
                    v-if="product.buttonaction == 'url' || product.buttonaction == 'buy'"
                    class="form-control"
                  >
                    <label class="caption" for="buttonNameInput">{{ $t('Button Name') }}</label>
                    <input
                      id="buttonNameInput"
                      v-model="product.buttonname"
                      type="text"
                      class="form-control"
                      aria-describedby="Button Name"
                      :placeholder="$t('Button Name')"
                    />
                  </div>
                </div>
                <div class="col s12 m6">
                  <div v-if="product.buttonaction == 'url'" class="form-control">
                    <label class="caption" for="buttonUrlInput">{{ $t('Product Url') }}</label>
                    <input
                      id="buttonUrlInput"
                      v-model="product.buttonurl"
                      type="text"
                      class="form-control"
                      aria-describedby="Button Url"
                      :placeholder="$t('Product Url')"
                    />
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>
      </div>
    </div>
    <div v-if="currentView == 'product'" class="text-xs-center">
      <v-btn outline color="grey" @click="cancelProduct">{{ $t('cancel') }}</v-btn>
      <v-btn depressed color="primary" @click="saveProduct">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import SelectCategory from './SelectCategory'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import UploadMultipleFile from '@/components/elements/UploadMultipleFile'
import ProductStock from './ProductStock'
import ScgdisProductStock from './ScgdisProductStock'
import ProductBundle from './ProductBundle'
import Tags from '@/components/elements/Tags'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import RunkanDatetime from './RunkanDatetime.vue'
import Label from '../../../elements/label.vue'

import { VueEditor } from 'vue2-editor'

export default {
  inject: ['$validator'],
  props: ['category', 'selectCategory', 'powerbuyFilterBranch'],
  data: function () {
    return {
      currentView: 'product',
      productImages: [],
      product: {
        photourl: null,
        name: null,
        description: null,
        price: null,
        discountprice: 0,
        currency: 'THB',
        categoryid: null,
        subcategoryid: 0,
        keyword: '',
        code: '',
        buttonaction: 'url',
        buttonname: '',
        buttonurl: '',
        productstock: null,
        weight: null,
        photohash: null, //อัพโหลด bg ของ ผลวิ่ง
        source: null //อัพโหลด bg ของ  e-cert
      },
      tag: '',
      runkandate: {},
      currentCategory: null,
      showAdvanced: false,
      deleteStockList: [],
      deleteBundleList: [],
      productstock: null,
      productbundle: [],
      loadingStock: null,
      loadingBundle: null,
      stock_process_count: 0,
      bundle_process_count: 0,
      isLoadingBundle: true,
      errorTag: [],
      productstockcategories: [],
      oldStock: [],

      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ direction: 'rtl' }], // text direction

        [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        [{ font: [] }],
        [{ align: [] }]
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    defaultStock() {
      return this.$store.state.nestlePages.some(
        (page) => this.selectedBot && page.pageid == this.selectedBot.pageid
      )
        ? 0
        : 999
    },
    currencySign: function () {
      if (this.product && this.product.currency) {
        switch (this.product.currency.toUpperCase()) {
          case 'THB':
            return '฿'
          case 'MMK':
            return 'K'

          default:
            return '$'
        }
      }
      return '$'
    },
    pageid: function () {
      return this.$store.state.selectedBot.pageid
    },

    tags: {
      get() {
        let vm = this
        if (vm.product.keyword != '') {
          var tags = vm.product.keyword.split(',')
          var result = []
          $.each(tags, function (index, val) {
            result.push({ text: val })
          })
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        $.each(value, function (index, val) {
          result.push(val.text)
        })
        vm.product.keyword = result.join()
      }
    }
  },
  watch: {
    selectCategory: function (newVal, oldVal) {
      var vm = this
      if (Number.isInteger(vm.selectCategory)) {
        vm.currentCategory = vm.selectCategory
      } else {
        vm.currentCategory = vm.selectCategory[0]
      }
    },
    'product.price': function (newVal, oldVal) {
      this.product.discountprice = newVal
    }
  },
  mounted: async function () {
    var vm = this
    // vm.$refs.name.focus();
    await this.$nextTick()
    this.setProductStock()
    if (this.selectedBot.theme == 'scgdistribution') {
      this.product.price = 0
      this.product.discountprice = 0
    }
    goTo(0)

    if (Number.isInteger(vm.selectCategory)) {
      vm.currentCategory = vm.selectCategory
    } else {
      vm.currentCategory = vm.selectCategory[0]
    }

    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  },
  components: {
    SelectCategory: SelectCategory,
    uploadfile: uploadfile,
    Tags,
    UploadMultipleFile,
    ProductStock,
    ProductBundle,
    RunkanDatetime,
    ScgdisProductStock,
    Label,
    VueEditor
  },
  methods: {
    setProductStock() {
      this.productstock = [[null, 'Normal', this.defaultStock, null, null]]
      this.$set(this.product, 'productstock', [[null, 'Normal', this.defaultStock, null, null]])
    },
    updateCategory(category) {
      this.productstockcategories = category
    },
    cancelProduct: function () {
      this.product = {
        photourl: null,
        name: null,
        description: null,
        price: null,
        discountprice: 0,
        currency: 'THB',
        categoryid: null,
        subcategoryid: 0,
        keyword: '',
        code: '',

        buttonaction: 'url',
        buttonname: '',
        buttonurl: '',

        productstock: null,
        weight: null
      }
      this.productstock = null
      this.setProductStock()
      this.productbundle = []
      if (Number.isInteger(this.selectCategory)) {
        this.currentCategory = this.selectCategory
      }
      this.$emit('close')
    },
    onChangeCategory: function (payload) {
      this.currentCategory = payload
      this.product.categoryid = this.currentCategory
    },
    saveProduct: async function () {
      let vm = this
      let product = vm.product

      var result = await vm.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        vm.goToErrorInput()
        return false
      }

      product.name = product.name.trim()

      product.pageid = vm.pageid
      product.categoryid = vm.currentCategory
      product.photourl = vm.productImages ? vm.productImages.join(';;') : ''
      product.productstockcategories = JSON.stringify(vm.productstockcategories)
      if (vm.selectedBot.theme == 'runkan') {
        Object.assign(product, this.runkandate)
      }

      if (vm.selectedBot.theme == 'foodguru') {
        Object.assign(product, { producttype: this.product.producttype })
      }
      vm.$store.dispatch('loading')

      if (['powerbuy'].includes(this.selectedBot.theme) && this.powerbuyFilterBranch) {
        Object.assign(product, { shop_main_pageid: this.powerbuyFilterBranch.shop_main_pageid })
      }

      try {
        var response = await vm.postProduct(product)
        product.id = response.productid

        vm.productImages = []
        vm.product.categoryid = vm.currentCategory.id
        vm.product.id = response.productid

        await vm.saveStock()
        if (vm.$store.getters.getPackage === 'premium') {
          await vm.saveBundle()
        }
        vm.completeSaveProduct(product)
      } catch (error) {
        console.error(error)
        vm.$store.dispatch('loading')
      }
    },
    postProduct(product) {
      return new Promise((resolve, reject) => {
        api.saveProduct(product, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    completeSaveProduct: function (product) {
      this.$emit('onAddProduct', product)
      this.cancelProduct()
    },
    saveStock: async function () {
      let vm = this

      vm.stock_process_count = vm.productstock.length + vm.deleteStockList.length

      var promiseUpdateProductStock = []

      $.each(vm.productstock, function (index, value) {
        let stock = {
          id: value[0],
          option: value[1],
          productid: vm.product.id,
          quantity: value[2],
          sku: value[5] ? value[5] : '',
          orders: index,
          photourl: value[7] ? value[7] : null
        }
        if (vm.selectedBot.theme == 'scgdistribution') {
          Object.assign(stock, { quantitylimit: value[8] ? value[8] : null })
        }

        if (value[3] === '' || parseFloat(value[3]) === 0) {
          stock.price = null
        } else {
          stock.price = value[3]
        }

        if (value[4] === '' || parseFloat(value[4]) === 0) {
          stock.discountprice = null
        } else {
          stock.discountprice = value[4]
        }

        if (value[0] === null) {
          promiseUpdateProductStock.push(
            vm.saveProductStock(stock).then((response) => {
              vm.productstock[index][0] = response.productstockid
            })
          )
        } else {
          promiseUpdateProductStock.push(vm.editProductStock(stock))
        }
      })

      await Promise.all(promiseUpdateProductStock)
    },
    saveProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.saveProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    editProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.editProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    deleteProductStock(stock) {
      return new Promise((resolve, reject) => {
        api.deleteProductStock(stock, function (error, response) {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    saveBundle: async function () {
      let vm = this

      vm.bundle_process_count = vm.productbundle.length + vm.deleteBundleList.length

      var promiseBundle = []
      $.each(vm.productbundle, function (index, value) {
        let bundle = value
        bundle.productid = vm.product.id

        if (bundle.id == null) {
          promiseBundle.push(
            vm.saveProductBundle(bundle).then((response) => {
              vm.productbundle[index].id = response.productbundleid
            })
          )
        } else {
          promiseBundle.push(vm.editProductBundle(bundle))
        }
      })

      await Promise.all(promiseBundle)

      var promiseDeleteBundle = []
      $.each(vm.deleteBundleList, function (index, val) {
        deleteProductBundle.push(vm.deleteProductBundle(val))
      })

      await Promise.all(promiseDeleteBundle)
    },
    saveProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.saveProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    editProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.editProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    deleteProductBundle(bundle) {
      return new Promise((resolve, reject) => {
        api.deleteProductBundle(bundle, function (error, response) {
          if (error) reject(error)
          resolve(response)
        })
      })
    },
    checkTag: function (obj) {
      this.errorTag = []
      if (this.tags.map((t) => t.text).indexOf(obj.tag.text) !== -1) {
        this.errorTag.push('duplicate')
      } else obj.addTag()
    },
    close: function () {
      this.$emit('onAddProduct', this.product)
    },
    deleteStock: function (id) {
      this.deleteStocklist.push(id)
    },
    deleteBundle: function (id) {
      this.deleteBundleList.push(id)
    }
  }
}
</script>

<style scroped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ModalAddProduct.vue